import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { AsyncDispatch } from '../../../../types/global';
import { ApplicationState } from '../../../reducers';
import AntMultiSelect from '../../global/AntMultiSelect';
import { updateAnalysesScorecardSelection } from '../../../actions/items/analyses/update';
import { fetchItemAnalyses } from '../../../actions/items/analyses/fetch';
import { activeScorecards } from '../../../selectors/settings/settingsSelector';
import { useAppDispatch } from '../../../store/ReduxStore';

const AnalysesScorecardSelect: React.FC = () => {
  const { t } = useTranslation();
  const dispatch: AsyncDispatch = useAppDispatch();

  const activeScorecardsList = useSelector((state: ApplicationState) => activeScorecards(state));
  const scorecardSelection = useSelector(
    (state: ApplicationState) => state.items.analyses.scorecardSelection
  );
  const selectedBrandId = useSelector(
    (state: ApplicationState) => state.parent.brands.selectedBrandId
  );
  const selectedItemIds = useSelector(
    (state: ApplicationState) => state.catalogue.catalogue.selectedItemIds
  );

  const selectedScorecardIds = React.useMemo(
    () => scorecardSelection[selectedBrandId] || [],
    [scorecardSelection, selectedBrandId]
  );

  const handleChange = (scorecardIds: number[]) => {
    dispatch(updateAnalysesScorecardSelection(selectedBrandId, scorecardIds));
    dispatch(fetchItemAnalyses(selectedItemIds, true, undefined, scorecardIds));
  };

  return (
    <AntMultiSelect
      className="analyses__scorecard-select"
      placeholder={t('analyses:filterAlerts')}
      elements={activeScorecardsList || []}
      selectedElements={selectedScorecardIds}
      onChange={handleChange}
      suffixIcon={null}
      size="small"
    />
  );
};

export default AnalysesScorecardSelect;
